import { Button, Grid, Typography, FormControlLabel, Checkbox, MenuItem, TextField as MdTextField } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import { userSchema } from '../CustomerUserContext';
import * as yup from 'yup';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Locale } from 'helpers/Enums';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { IoWarningOutline as WarningIcon } from 'react-icons/io5';

interface IUserForm {
    formProps: any
}

let UserForm = (props: IUserForm) => {
    let { formatMessage } = useIntl();
    let router = useLocation();

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? formatMessage({ id: LocalizationIds.NewUser }) : formatMessage({ id: LocalizationIds.EditUser });

    type User = yup.InferType<typeof userSchema>;
    let form = useFormikContext<User>();



    return (
        <Form>
            <Grid container>
                <Grid item xs>
                    <Typography variant="h1">{title}</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="email"
                        type="email"
                        disabled={isNew === false}
                        label={formatMessage({ id: LocalizationIds.Email })}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="firstName"
                        label={formatMessage({ id: LocalizationIds.FirstName })}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="lastName"
                        label={formatMessage({ id: LocalizationIds.LastName })}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <MdTextField
                        select
                        label={formatMessage({ id: LocalizationIds.Language })}
                        size="small"
                        value={form.values.language}
                        onChange={(e: any) => props.formProps.setFieldValue('language', e.target.value)}
                    >
                        <MenuItem key={Locale.Italian} value={Locale.Italian}>{formatMessage({ id: LocalizationIds.Italian })}</MenuItem>
                        <MenuItem key={Locale.English} value={Locale.English}>{formatMessage({ id: LocalizationIds.English })}</MenuItem>
                    </MdTextField>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControlLabel
                        label={formatMessage({ id: LocalizationIds.IsAdmin })}
                        name="isAdmin"
                        value={form.values.isAdmin}
                        checked={form.values.isAdmin}
                        onChange={(e: any) => form.setFieldValue('isAdmin', e.target.checked)}
                        control={<Field type="checkbox" name="isAdmin" component={Checkbox} color="secondary" />}
                    />
                </Grid>
                {isNew === true &&
                    <Grid item xs={12}>
                        <Typography color="primary">
                            <WarningIcon /> {formatMessage({ id: LocalizationIds.MailInviteWarning })}
                        </Typography>
                    </Grid>
                }


            </Grid>
            <Grid container>
                <Grid item xs style={{ textAlign: 'right' }}>
                    <Button
                        component={RouterLink}
                        variant="outlined"
                        color="secondary"
                        to={"/customer/users"}
                    >
                        {formatMessage({ id: LocalizationIds.Cancel })}
                    </Button>
                    <Button type="submit" variant="contained">
                        {formatMessage({ id: LocalizationIds.Save })}
                    </Button>
                </Grid>
            </Grid>

        </Form >
    );
}

export default UserForm;